/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { get } from 'lodash';
import moment from 'moment';
import FNumberFormatKm from '../../utils/FNumberFormatKm';
import { roundToTwoDecimal } from '../../utils/numberUtils';

const styles = StyleSheet.create({
  headerContainer: {
    marginTop: 5,
    marginLeft: 2,
    justifyContent: 'flex-start',
    width: '100%',
  },
  billTo: {
    // padding: 3,
    // fontFamily: 'Helvetica-Oblique',
    fontStyle: 'bold',
    textDecoration: 'underline',
  },
  invoiceDateContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  label: {
    width: 200,
    fontStyle: 'bold',
  },
  conteudo: {
    width: 200,
  },
});

function BillTo({ dados }) {
  const kmsaida = roundToTwoDecimal(Number(get(dados, 'kmsaida', '')));
  const kmretorno = roundToTwoDecimal(Number(get(dados, 'kmretorno', '')));
  const dtsaida = get(dados, 'saida')
    ? moment(get(dados, 'saida')).format('DD/MM/YYYY')
    : '--/--/----';
  const dtretorno = get(dados, 'retorno')
    ? moment(get(dados, 'retorno')).format('DD/MM/YYYY')
    : '--/--/----';
  return (
    <View style={styles.headerContainer}>
      <Text style={styles.billTo}>Detalhes da Viagem:</Text>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Motorista:</Text>
        <Text style={styles.conteudo}>{get(dados, 'Motoristum.nome', '')}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Placa:</Text>
        <Text style={styles.conteudo}>{get(dados, 'Veiculo.placa', '')}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Data Saída:</Text>
        <Text style={styles.conteudo}>{dtsaida}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Data Retorno:</Text>
        <Text style={styles.conteudo}>{dtretorno}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Km Saída:</Text>
        <Text style={styles.conteudo}>{FNumberFormatKm(kmsaida)}</Text>
      </View>
      <View style={styles.invoiceDateContainer}>
        <Text style={styles.label}>Km Retorno:</Text>
        <Text style={styles.conteudo}>{FNumberFormatKm(kmretorno)}</Text>
      </View>
    </View>
  );
}

export default BillTo;
